export default "__VITE_ASSET__E33addih__"